module.exports = __webpack_public_path__ + "static/img/top-bg.f83cba63.webp";